import { HttpClient, httpResource } from '@angular/common/http';
import type { Signal } from '@angular/core';
import { inject, Injectable } from '@angular/core';

import { DataInvalidationService } from '#/app/shared/services/data-invalidation.service';

import type {
  InletAssetResponse,
  UpdateInletAssetRequest,
} from '../../domain/assets/inlet-asset.model';
import { assertIsDefined } from '../../domain/types';
import type { ChartData } from '../../domain/ui/chart-data.model';
import { TenantContext } from '../tenant.context';

@Injectable({
  providedIn: 'root',
})
export class InletAssetService {
  readonly #httpClient = inject(HttpClient);
  readonly #tenantContext = inject(TenantContext);
  readonly #dataInvalidationService = inject(DataInvalidationService);

  inletAssetResource(inletAssetId: Signal<string>) {
    return httpResource<InletAssetResponse>(() => {
      const tenantId = this.#tenantContext.currentTenantId();
      const inletAssetIdValue = inletAssetId();
      return tenantId && inletAssetIdValue
        ? `api/tenants/${tenantId}/assets/inlets/${inletAssetIdValue}`
        : undefined;
    });
  }

  updateInletAsset(assetId: string, request: UpdateInletAssetRequest) {
    const tenantId = this.#tenantContext.currentTenantId();
    assertIsDefined(tenantId);
    return this.#httpClient.put<InletAssetResponse>(
      `api/tenants/${tenantId}/assets/inlets/${assetId}`,
      request,
    );
  }

  inletAssetCountByAgeResource() {
    return httpResource<ChartData[]>(() => {
      this.#dataInvalidationService.track('assets');
      const tenantId = this.#tenantContext.currentTenantId();
      return tenantId
        ? `api/tenants/${tenantId}/assets/inlets/visualization/count-by-age`
        : undefined;
    });
  }
}
